import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export function ConfirmDialog({
    isOpen,
    onOpenChange,
    onConfirm,
    title = "Confirmar exclusão",
    description = "Tem certeza que deseja realizar esta ação? Isso não poderá ser desfeito.",
    confirmLabel = "Excluir",
    cancelLabel = "Cancelar",
    variant = "destructive", // destructive | default
    isLoading: externalLoading = false
}) {
    const [internalLoading, setInternalLoading] = useState(false);
    const isLoading = externalLoading || internalLoading;

    const handleConfirm = async () => {
        try {
            setInternalLoading(true);
            await onConfirm();
            onOpenChange(false);
        } catch {
            // onConfirm threw — keep dialog open so user sees the error toast
        } finally {
            setInternalLoading(false);
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={(v) => { if (!isLoading) onOpenChange(v); }}>
            <DialogContent className="bg-background border-border sm:max-w-[425px]">
                <DialogHeader className="gap-2 sm:gap-4">
                    <div className="flex items-center gap-4">
                        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-500/10 border border-red-500/20">
                            <AlertTriangle className="h-5 w-5 text-red-500" />
                        </div>
                        <div className="flex flex-col gap-1 text-left">
                            <DialogTitle className="text-lg font-semibold text-foreground-strong">
                                {title}
                            </DialogTitle>
                            <DialogDescription className="text-foreground-muted text-sm">
                                {description}
                            </DialogDescription>
                        </div>
                    </div>
                </DialogHeader>

                <DialogFooter className="gap-2 sm:gap-0 mt-4">
                    <Button
                        variant="ghost"
                        onClick={() => onOpenChange(false)}
                        className="hover:bg-surface-hover text-foreground-muted hover:text-foreground"
                        disabled={isLoading}
                    >
                        {cancelLabel}
                    </Button>
                    <Button
                        variant={variant === 'destructive' ? 'destructive' : 'default'}
                        onClick={handleConfirm}
                        className="bg-red-600 hover:bg-red-700 text-white border-none"
                        disabled={isLoading}
                    >
                        {isLoading && (
                            <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
                        )}
                        {confirmLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
